"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _inputHelperText = _interopRequireDefault(require("../input-helper-text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormControlLabel = function FormControlLabel(props) {
  var className = props.className,
      control = props.control,
      disabled = props.disabled,
      isError = props.error,
      InputHelperTextProps = props.InputHelperTextProps,
      label = props.label,
      restOfProps = _objectWithoutProperties(props, ["className", "control", "disabled", "error", "InputHelperTextProps", "label"]);

  if (!label) return null;
  var controlProps = {
    disabled: disabled,
    error: isError
  };
  ['checked', 'name', 'onChange', 'value'].forEach(function (key) {
    if (props[key]) {
      controlProps[key] = props[key];
    }
  });
  /**
   * If a "helperText" is used, a "helperTextId" should also be provided to link
   * "aria-describedby" on the input with the helper text id for accessibility
   */

  var HelperTextProps = InputHelperTextProps ? _objectSpread({}, InputHelperTextProps) : {};
  /**
   * Provide an id for the helperText only if it is not explicitly defined by users
   */

  if (!HelperTextProps.id) {
    HelperTextProps.id = "".concat(controlProps.id, "-helper-text");
  }

  var labelClasses = (0, _classnames.default)(className, {
    'pds-form-control-label': true,
    'pds-form-control-label--error': isError,
    'pds-form-control-label--disabled': disabled
  });
  /* eslint-disable jsx-a11y/label-has-for */

  return _react.default.createElement("label", _extends({
    className: labelClasses,
    htmlFor: controlProps.id
  }, restOfProps), (0, _react.cloneElement)(control, controlProps), _react.default.createElement("div", {
    className: "pds-form-control-label__title"
  }, label, _react.default.createElement(_inputHelperText.default, {
    className: HelperTextProps.className,
    id: HelperTextProps.id,
    disabled: disabled,
    text: isError ? HelperTextProps.errorText : HelperTextProps.text,
    active: true,
    error: isError
  })));
};

FormControlLabel.propTypes = {
  className: _propTypes.string,
  control: _propTypes.element.isRequired,
  disabled: _propTypes.bool,
  error: _propTypes.bool,
  InputHelperTextProps: (0, _propTypes.shape)({
    className: _propTypes.string,
    errorText: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)]),
    errorTextClassName: _propTypes.string,
    id: _propTypes.string,
    text: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)])
  }).isRequired,
  label: _propTypes.string
};
FormControlLabel.defaultProps = {
  className: null,
  disabled: false,
  error: false,
  label: null
};
var _default = FormControlLabel;
exports.default = _default;
